<!-- job-post-home.component.html -->
<!-- ===== HERO SECTION ===== -->
<section class="jp-hero-section">
  <img
    class="jp-hero-bg"
    src="assets/img/9d8a4709a68216d76b16b068b301a4460f369216.png"
    alt="Job Post Hero"
  />

  <div class="jp-hero-center">
    <div class="jp-glass-card">
      <div class="jp-glass-card__frost" aria-hidden="true"></div>
      <div class="jp-glass-card__tint" aria-hidden="true"></div>

      <div class="jp-glass-card__content">
        <div class="jp-hero-badge">
          <span class="jp-badge-star">✦</span>
          <span>Introducing AI Virtual Interviews</span>
        </div>

        <h1 class="jp-hero-title">
          Create Job Posts That Attract the<br />Right Talent
        </h1>

        <p class="jp-hero-subtitle">
          Publish professional job posts, manage applicants in one place, and
          seamlessly move qualified candidates into AI-powered virtual
          interviews.
        </p>

        <button class="jp-hero-cta" routerLink="/company-admin/add-job">
          <span>Start Hiring</span>
          <span class="jp-cta-arrow">
            <i class="bi bi-arrow-up-right"></i>
          </span>
        </button>
      </div>
    </div>
  </div>
</section>



<!-- ===== WHY TOP TEAMS ===== -->
<app-why-top-teams></app-why-top-teams>

<!-- ===== HOW IT WORKS ===== -->
<section class="jp-how-section">
  <div class="jp-section-inner">
    <div class="jp-section-header">
      <h2 class="jp-section-title">How It Works</h2>
    </div>
    <div class="jp-steps-track">
      <div class="jp-steps-line"></div>
      <div class="jp-step-item" *ngFor="let step of howItWorksSteps">
        <div class="jp-step-circle">{{ step.number }}</div>
        <h4 class="jp-step-title">{{ step.title }}</h4>
      </div>
    </div>
  </div>
</section>

<!-- ===== PROMOTE YOUR JOB POSTS ===== -->
<section class="jp-promote-section">
  <div class="jp-section-inner">
    <div class="jp-section-header">
      <h2 class="jp-section-title">Promote Your Job Posts</h2>
      <p class="jp-section-subtitle">
        Reach the right candidates faster with targeted promotions.
      </p>
      <div class="jp-promo-badge">
        *All promotional services are complimentary for the first 3 months.
      </div>
    </div>
    <div class="jp-promo-grid">
      <div class="jp-promo-card" *ngFor="let plan of plans">
        <div
          class="jp-promo-icon"
          [ngStyle]="{ 'background-color': plan.iconBg, color: plan.iconColor }"
        >
          <i class="{{ plan.icon }}"></i>
        </div>
        <h3 class="jp-promo-name">{{ plan.name }}</h3>
        <p class="jp-promo-desc">{{ plan.description }}</p>
      </div>
    </div>
  </div>
</section>

<!-- ===== DASHBOARD PREVIEW ===== -->
<section class="jp-dashboard-section">
  <div class="jp-section-inner">
    <div class="jp-section-header">
      <h2 class="jp-section-title">
        Everything You Need to Build Great Job Posts
      </h2>
      <p class="jp-section-subtitle">
        Powerful tools to craft compelling descriptions and attract top talent.
      </p>
    </div>
    <div class="jp-dashboard-visual-center">
      <div class="jp-dashboard-img-wrap">
        <img
          src="assets/img/company/Frame 2095588644.png"
          alt="Dashboard Preview"
          class="jp-dashboard-img-full"
        />
      </div>
    </div>
  </div>
</section>

<!-- ===== AI VIRTUAL INTERVIEWS SECTION ===== -->
<section class="jp-ai-interviews-section">
  <div class="jp-section-inner">
    <div class="jp-section-header">
      <h2 class="jp-section-title">
        Seamlessly Connected with AI Virtual Interviews
      </h2>
      <p class="jp-section-subtitle">
        Move effortlessly from receiving applications to evaluating candidates with
        integrated AI interview capabilities.
      </p>
    </div>
    <div class="jp-ai-cards-row">
      <!-- Card 1 -->
      <div class="jp-ai-card">
        <div class="jp-ai-card-icon">
          <i class="bi bi-clipboard2-check"></i>
        </div>
        <h4 class="jp-ai-card-title">Job Applications</h4>
        <p class="jp-ai-card-desc">Review resumes & shortlists</p>
      </div>
      <!-- Arrow -->
      <div class="jp-ai-arrow">
        <i class="bi bi-arrow-right"></i>
      </div>
      <!-- Card 2 (Highlighted) -->
      <div class="jp-ai-card jp-ai-card--active">
        <div class="jp-ai-card-icon">
          <i class="bi bi-robot"></i>
        </div>
        <h4 class="jp-ai-card-title">AI Virtual Interview</h4>
        <p class="jp-ai-card-desc">Automated candidate screening</p>
      </div>
      <!-- Arrow -->
      <div class="jp-ai-arrow">
        <i class="bi bi-arrow-right"></i>
      </div>
      <!-- Card 3 -->
      <div class="jp-ai-card">
        <div class="jp-ai-card-icon">
          <i class="bi bi-award"></i>
        </div>
        <h4 class="jp-ai-card-title">Hiring Decision</h4>
        <p class="jp-ai-card-desc">Make the perfect offer</p>
      </div>
    </div>
  </div>
</section>

<!-- ===== START ACHIEVING SECTION ===== -->
<app-start-achieving-section></app-start-achieving-section>
